import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card004AdultInnerWorkMontessori() {
  return <KbCardPage slug="card-004-adult-inner-work-montessori" />;
}

(Card004AdultInnerWorkMontessori as unknown as { path: string }).path = "/methodology/004";
